import React from 'react';
import { FormattedMessage } from 'react-intl';

import Box from 'carbon-react/lib/components/box';

import { USER_ROLE_IDS } from '../constants';

import styles from './user-role-explanations.scss';

interface UserRoleExplanationsProps {
  roleId: string;
}

export const UserRoleExplanations = ({ roleId }: UserRoleExplanationsProps) => {
  const explanations = (() => {
    switch (roleId) {
      case USER_ROLE_IDS.SUPER_ADMIN:
        return [
          <FormattedMessage
            key="predict.workspaces.users.has_access_all_orgs"
            id="predict.workspaces.users.has_access_all_orgs"
            defaultMessage="Has access to all organisations in this workspace"
          />,
          <FormattedMessage
            key="predict.workspaces.users.can_invite_any_role"
            id="predict.workspaces.users.can_invite_any_role"
            defaultMessage="Can invite new users with any role"
          />,
          <FormattedMessage
            key="predict.workspaces.users.can_add_org"
            id="predict.workspaces.users.can_add_org"
            defaultMessage="Can add new organisations"
          />
        ];
      case USER_ROLE_IDS.ADMINISTRATOR:
        return [
          <FormattedMessage
            key="predict.workspaces.users.has_access_org_invite"
            id="predict.workspaces.users.has_access_org_invite"
            defaultMessage="Has access to organisations selected in this invite"
          />,
          <FormattedMessage
            key="predict.workspaces.users.can_invite_new_users_to_only_selected_organisations"
            id="predict.workspaces.users.can_invite_new_users_to_only_selected_organisations"
            defaultMessage="Can invite new users to only those selected organisations with administrator, people manager, data manager or guest roles"
          />,
          <FormattedMessage
            key="predict.workspaces.users.can_add_org"
            id="predict.workspaces.users.can_add_org"
            defaultMessage="Can add new organisations"
          />
        ];
      case USER_ROLE_IDS.PEOPLE_MANAGER:
        return [
          <FormattedMessage
            key="predict.workspaces.users.has_access_org_invite"
            id="predict.workspaces.users.has_access_org_invite"
            defaultMessage="Has access to organisations selected in this invite"
          />,
          <FormattedMessage
            key="predict.workspaces.users.can_invite_new_users_to_only_those_organisations"
            id="predict.workspaces.users.can_invite_new_users_to_only_those_organisations"
            defaultMessage="Can invite new users to only those organisations with people manager, data manager or guest roles"
          />,
          <FormattedMessage
            key="predict.workspaces.users.cannot_add_new_organisations"
            id="predict.workspaces.users.cannot_add_new_organisations"
            defaultMessage="Cannot add new organisations"
          />
        ];
      case USER_ROLE_IDS.DATA_MANAGER:
        return [
          <FormattedMessage
            key="predict.workspaces.users.has_access_org_invite"
            id="predict.workspaces.users.has_access_org_invite"
            defaultMessage="Has access to organisations selected in this invite"
          />,
          <FormattedMessage
            key="predict.workspaces.users.cannot_invite_users"
            id="predict.workspaces.users.cannot_invite_users"
            defaultMessage="Cannot invite users"
          />,
          <FormattedMessage
            key="predict.workspaces.users.can_add_org"
            id="predict.workspaces.users.can_add_org"
            defaultMessage="Can add new organisations"
          />
        ];
      case USER_ROLE_IDS.GUEST:
        return [
          <FormattedMessage
            key="predict.workspaces.users.has_access_org_invite"
            id="predict.workspaces.users.has_access_org_invite"
            defaultMessage="Has access to organisations selected in this invite"
          />,
          <FormattedMessage
            key="predict.workspaces.users.cannot_invite_new_users"
            id="predict.workspaces.users.cannot_invite_new_users"
            defaultMessage="Cannot invite new users"
          />,
          <FormattedMessage
            key="predict.workspaces.users.cannot_add_new_organisations"
            id="predict.workspaces.users.cannot_add_new_organisations"
            defaultMessage="Cannot add new organisations"
          />
        ];
      default:
        return [];
    }
  })();

  if (!explanations.length) {
    return null;
  }

  return (
    <Box as="ul" className={styles.list} mt={1} mb={3} pl={3}>
      {explanations.map((explanation, index) => (
        <li key={index}>{explanation}</li>
      ))}
    </Box>
  );
};
